// What Free webinars and a replay's own page (Adam, 23 Oct) both read beyond the Library's rows: every
// webinar the member can see and their place in each replay (load.js), with Try again, and their place
// kept here once it's saved, so "Carry on from" and "Paused at" follow them.
import { useCallback, useEffect, useState } from 'react'
import { loadWebinarPage, saveReplayPosition } from './load.js'

export function useWebinarPage(personId) {
  const [page, setPage] = useState({ status: 'loading', data: null })

  const load = useCallback(() => {
    setPage({ status: 'loading', data: null })
    loadWebinarPage(personId)
      .then(data => setPage({ status: 'ready', data }))
      .catch(() => setPage({ status: 'error', data: null }))
  }, [personId])
  useEffect(() => { load() }, [load])

  const savePosition = useCallback((webinarId, seconds) => {
    setPage(p => {
      if (!p.data) return p
      const rest = p.data.progress.filter(r => r.webinar_id !== webinarId)
      return { ...p, data: { ...p.data, progress: [...rest, { webinar_id: webinarId, position_seconds: seconds }] } }
    })
    saveReplayPosition(personId, webinarId, seconds).catch(() => { /* the next save tries again */ })
  }, [personId])

  return { page, load, savePosition }
}
